import { Description } from '@monorepo/shared/componentsV2/Description';
import { AnalyticsSyncDetailsSection } from '@monorepo/shared/componentsV2/fullPageWizard/AnalyticsSyncWizardStep/AnalyticsSyncDetailsSection';
import {
  Content,
  Page,
  SectionContainer,
  SectionHeader,
} from '@monorepo/shared/componentsV2/fullPageWizard/styled/fullPageWizard';
import { Loading } from '@monorepo/shared/componentsV2/Loading';
import { useWorkflow } from '@monorepo/shared/hooks/workflows/useWorkflow';
import React from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import { WorkflowStepCard } from '../EditWorkflowStepsPage/WorkflowStepCard';
import { WorkflowStepsDiagram } from '../EditWorkflowStepsPage/WorkflowStepsDiagram';
import { WorkflowIncompleteDataMessages } from '../shared/WorkflowIncompleteDataMessages';
import { WorkflowOutputPreview } from '../shared/WorkflowOutputPreview';
import { WorkflowDetailsHeader } from './WorkflowDetailsHeader';

const ListContainer = styled.div`
  margin-top: 1.25rem;
  margin-bottom: 1.25rem;
`;

const StyledWorkflowStepCard = styled(WorkflowStepCard)`
  margin-bottom: 0.625rem;
`;

const StyledWorkflowIncompleteDataMessages = styled(
  WorkflowIncompleteDataMessages,
)`
  margin-bottom: 1.25rem;
`;

const OutputPreviewContainer = styled.div`
  max-width: 40rem;
  padding: 20px 0;
  border: ${({ theme }) => `1px solid ${theme.colors.grayddd}`};
  border-radius: 4px;
`;

export function WorkflowDetailsPage() {
  const { organizationId, workflowId } = useParams();
  const { workflow, isLoading: isWorkflowLoading } = useWorkflow({
    organizationId,
    workflowId,
  });
  if (!organizationId || !workflowId) {
    throw new Error(
      'WorkflowDetailsPage was rendered in a context without organization or/and workflow id',
    );
  }

  if (isWorkflowLoading) {
    return (
      <Page>
        <Loading />
      </Page>
    );
  }

  if (!workflow || !organizationId) {
    throw new Error("Couldn't get information about this Workflow.");
  }

  return (
    <Page>
      <WorkflowDetailsHeader
        organizationId={organizationId}
        workflow={workflow}
      />
      <Content>
        <StyledWorkflowIncompleteDataMessages workflow={workflow} />
        <SectionContainer>
          <SectionHeader>Workflow Details</SectionHeader>
          <Description>
            {workflow.description || 'No Workflow description.'}
          </Description>
          <WorkflowStepsDiagram
            organizationId={organizationId}
            workflowId={workflow.id}
          />
        </SectionContainer>
        <AnalyticsSyncDetailsSection
          datasetOriginId={workflow.id}
          organizationId={organizationId}
          datasetId={workflow.outputDataset.id}
          datasetOriginLabel="Workflow"
        />
        <SectionContainer>
          <SectionHeader>Steps</SectionHeader>
          <ListContainer>
            {workflow.steps.map((step) => (
              <StyledWorkflowStepCard
                key={step.id}
                organizationId={organizationId}
                showMenu={false}
                step={step}
              />
            ))}
          </ListContainer>
        </SectionContainer>
        <SectionContainer>
          <SectionHeader>Output</SectionHeader>
          <Description>Visualization of Workflow output data.</Description>
          <br />
          <OutputPreviewContainer>
            <WorkflowOutputPreview
              propertyAncestry={workflow.outputDataset.propertyAncestry}
            />
          </OutputPreviewContainer>
        </SectionContainer>
      </Content>
    </Page>
  );
}
